import SearchesPage from './searches-page';

export default SearchesPage;
